import { restoreInternalLink, showLinkAnchors } from "#/admin/legacy/page-builder/link-dialog.js";
import { settleMount } from "#ce/framework/mount-ready";

class InternalLink {
  constructor(searchElement, anchorElement) {
    this.searchElement = jQuery(searchElement); // Need reference to this since this element comes from ruby;
    this.searchElement.find(".submit_button").hide();
    this.previewEl = this.buildPreview();
    this.anchorEl = anchorElement?.nodeType ? anchorElement : anchorElement?.[0];

    this.previewEl.find(".toggle").click(() => {
      this.url = "";
      this.searchElement.removeClass("visually-hidden");
      this.previewEl.addClass("visually-hidden");
      this.anchorEl.classList.add("visually-hidden");
    });
  }

  get value() {
    if (!this.url) {
      return false;
    }

    let href = new URL(this.url);
    href.hash = this.hash;

    return href.toString();
  }

  get defaultTitle() {
    return this.previewEl.find("#link-preview-link").text();
  }

  buildPreview() {
    return jQuery(`<div id="link-preview" class="link-dialog-form-group visually-hidden">
      <a href="#" class="toggle">Change</a>
      <div id="link-preview-link-container">
        <span id="link-preview-icon"></span>
        <a id="link-preview-link" target="_blank" title="Click to view this link in a new tab"></a>
      </div>
    </div>`);
  }

  /** Resolves once the link holds `suggestion`'s URL, whether or not its metadata loads. */
  update(suggestion) {
    let internalURL = suggestion.sparkleUrl || suggestion;
    this.updateHash(internalURL);
    return this.updateURL(internalURL);
  }

  updateHash(url) {
    let href = new URL(url);
    this.setHash(href.hash);
  }

  updateURL(url) {
    return restoreInternalLink(this, url);
  }

  fetchResourceMetadata(url) {
    var transformedUrl = url.replace(/sparkle:\/\//, "/").replace(/#.*/, "");
    return jQuery.get("/admin" + transformedUrl + "/meta_data.json");
  }

  updatePreview(data) {
    this.searchElement.addClass("visually-hidden");
    this.previewEl.removeClass("visually-hidden");
    this.previewEl.find("#link-preview-icon").html(data.icon);
    this.formatPreviewInput(data);
  }

  formatPreviewInput(data) {
    let internalLinkPreview = this.previewEl.find("#link-preview-link");

    internalLinkPreview.toggleClass("link-preview-label-small", data.label.length > 50);
    internalLinkPreview.html(data.label);
    internalLinkPreview.attr("href", data.url);
  }

  async updateAnchors(data) {
    if (!(await settleMount(this.anchorEl.querySelector("#link-anchor-select")))) {
      return;
    }

    showLinkAnchors(this.anchorEl, data, this.hash, this.setHash.bind(this));
  }

  setURL(url) {
    this.url = url;
  }

  setHash(hash) {
    this.hash = hash ?? "";
  }

  hideDisabledModals() {
    // // Hide types of models not available in this publishing domain
    this.searchElement.find('[name="page_type"]').each(function () {
      var val = jQuery(this).val();

      // Always include the everything search
      if (!val) {
        return;
      }

      // SEARCHABLE_MODELS is defined nowhere in the JavaScript, so this throws and no page type is
      // hidden: https://github.com/combinaut/sparkle/issues/30289
      // eslint-disable-next-line no-undef
      if (SEARCHABLE_MODELS.indexOf(val) === -1) {
        jQuery(this).closest("li").hide();
      }
    });
  }
}

window.InternalLink = InternalLink;
